import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const CardPolicyAndProceduresSchema = z.object(
  {
    mesa_cardholder_agreement: z.string(),
    mesa_privacy_policy: z.string(),
    celtic_bank_privacy_policy: z.string(),
    mesa_privacy_notice: z.string(),
    terms_of_service: z.string(),
    'e-sign_consent_policy': z.string(),
    credit_report_authorization_notice: z.string(),
    cardholder_rewards_terms_of_use: z.string(),
    usa_patriot_act_notice: z.string(),
    mesa_cardholder_agreement_preview_img: z.string(),
    mesa_refer_a_cardholder_terms_and_conditions: z.string(),
    partner: z
      .record(
        z.string(),
        z.object({
          cardholder_agreement: z.string(),
          rewards_terms_of_use: z.string(),
          benefits_terms_of_use: z.string().optional(),
        }),
      )
      .optional(),
  },
  { message: 'CardPolicyAndProceduresSchema must be a valid object' },
)

export type CardPolicyAndProcedures = z.infer<typeof CardPolicyAndProceduresSchema>

export function useCardPolicyAndProcedures() {
  return useMesaParameterStore('card_policy_and_procedures')
}
